import User from '@/utils/User.js';
const FileInfo = {
	async getFileUrlAsync(urlName) {
		try {
			const response = await fetch(`/webL_api/third/files/info/${urlName}`, {
				headers: {
					Authorization: 'Bearer ' + User.getToken()
				}
			});
			// console.log('response', response);
			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			const arrayBuffer = await response.arrayBuffer();
			const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
			const imageUrlData = URL.createObjectURL(blob);
			// console.log('图片地址:', imageUrlData);
			return imageUrlData;
		} catch (error) {
			console.error('获取图片失败:', error);
			return null;
		}
	},

	getFileUrl(urlName) {
		return new Promise((resolve, reject) => {
			fetch(`/webL_api/third/files/info/${urlName}`, {
				headers: {
					Authorization: 'Bearer ' + User.getToken()
				}
			})
				.then(response => {
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}
					return response.arrayBuffer();
				})
				.then(arrayBuffer => {
					const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
					const imageUrlData = URL.createObjectURL(blob);
					// console.log('图片地址-同步代码:', imageUrlData);
					resolve(imageUrlData);
				})
				.catch(error => {
					console.error('获取图片失败:', error);
					reject(null);
				});
		});
		
	}
};

export default FileInfo;
